export const environment = {
  production: true,
  // apiUrl: 'http://localhost:8080/',
  apiUrl: 'https://www.alergolog.md/',
  appUrl: 'https://www.alergolog.md',
  googleCloudFileUrl: '',
  recaptchaKey: '6LeE2ZYpAAAAADieFdZ0XSrwvnv8y-1lI9Q-OLQl',
  secretKey: 123,
  streamApiKey: 'hk84ggh2cmcx'
};
